import { Col, Divider,  Flex, Row } from "antd";
import { PaymentInfo } from "../../../../../features/Vendor/vendor.type";
import BankCard from "./BankCard";
import MFSCard from "./MFSCard";
import Empty from "../../../../../assets/icons/Empty";

const PaymentDetails = ({ data }: { data?: PaymentInfo[] }) => {
  const banksInfos = data?.filter(
    (item) => item?.payment_type?.toLowerCase() === "bank",
  );
  const mfsInfos = data?.filter(
    (item) => item?.payment_type?.toLowerCase() === "mfs",
  );

  return (
    <div className="space-y-6 border border-indigo-50 p-5 mt-5 rounded-xl">
      <h5 className="text-lg text-theme-gray-2 font-semibold">
        Bank Information
      </h5>
      <Row gutter={[24, 24]}>
        {banksInfos?.length ? (
          banksInfos?.map((data, index) => (
            <Col span={12} key={index}>
              <BankCard data={data} />
            </Col>
          ))
        ) : (
          <Flex justify="center" align="center" className="w-full">
            <Empty />
          </Flex>
        )}
      </Row>
      <Divider className="bg-theme-slate-200" />
      <h5 className="text-lg text-theme-gray-2 font-semibold">MFS Account</h5>
      <Row gutter={[24, 24]}>
        {mfsInfos?.length ? (
          mfsInfos?.map((data, index) => (
            <Col span={6} key={index}>
              <MFSCard data={data} />
            </Col>
          ))
        ) : (
          <Flex justify="center" align="center" className="w-full">
            <Empty />
          </Flex>
        )}
      </Row>
    </div>
  );
};

export default PaymentDetails;
